export default __webpack_public_path__ + "static/media/new2.326b6a7f.jpg";